/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useEffect, useState } from "react";

const safeString = (val) => {
  if (val === null || val === undefined) return "";
  if (typeof val === "string") return val.trim();
  if (typeof val === "number" || typeof val === "boolean") return String(val);
  if (typeof val === "object") {
    if (val.text) return String(val.text).trim();
    if (val.value) return String(val.value).trim();
    if (val.name) return String(val.name).trim();
  }
  try {
    return String(val).trim();
  } catch {
    return "";
  }
};

export default function usePlans(isArabic) {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        setLoading(true);

        const baseUrl =
          process.env.NODE_ENV === "development"
            ? "/api"
            : process.env.REACT_APP_API_BASE_URL ||
            "https://madar-api.madar.iq/api";

        const res = await fetch(`${baseUrl}/Plans/GetPlan?PlanId=-1`);
        const data = await res.json();

        if (!Array.isArray(data)) {
          setPlans([]);
          return;
        }

        const activePlansOnly = data.filter(
          (p) => Number(p.isActive) === 1
        );

        const formatted = activePlansOnly.map((p) => {
          const title = isArabic
            ? safeString(p.planType) || safeString(p.engPlanType) || "باقة"
            : safeString(p.engPlanType) || safeString(p.planType) || "Plan";

          const desc = isArabic
            ? safeString(p.descripsion) || safeString(p.engDescripsion)
            : safeString(p.engDescripsion) || safeString(p.descripsion);

          const notes = [];
          for (let i = 1; i <= 8; i++) {
            const note = isArabic ? p[`note${i}`] : p[`engNote${i}`];
            const cleanNote = safeString(note);
            if (cleanNote) notes.push(cleanNote);
          }

          const price = Number(p.price) || 0;

          return {
            id: p.id || p.planId,
            title,
            desc,
            price,
            notes,
          };
        });

        setPlans(formatted);
      } catch {
        setPlans([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, [isArabic]);

  return { plans, loading };
}
